<template>
    <div>
        <b-card-code
                title="Szerkesztés"
        >
            <b-overlay
                    :show="loading"
                    spinner-variant="primary"
                    spinner-type="grow"
                    rounded="sm"
            >
                <!-- form -->
                <validation-observer ref="simpleRules">
                    <b-form>
                        <b-row>
                            <b-col md="6">
                                <b-form-group
                                        label="Felhasználó"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="felhasználó"
                                            rules="required"
                                            vid="user"
                                    >
                                        <b-overlay
                                                :show="userSelectLoading"
                                                spinner-variant="primary"
                                                spinner-type="grow"
                                                rounded="sm"
                                        >
                                            <v-select
                                                    v-model="formData.user"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    label="title"
                                                    :clearable="false"
                                                    :options="userOptions"
                                                    @input="refreshFishermen()"
                                            >
                                                <template #no-options>
                                                    <span style="">Sajnáljuk, nincs egyező találat.</span>
                                                </template>
                                            </v-select>
                                        </b-overlay>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="6">
                                <b-form-group
                                        label="Horgász"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="horgász"
                                            rules="required"
                                            vid="fisherman"
                                    >
                                        <b-overlay
                                                :show="fishermanSelectLoading"
                                                spinner-variant="primary"
                                                spinner-type="grow"
                                                rounded="sm"
                                        >
                                            <b-input-group
                                                    :class="errors.length > 0 ? 'is-invalid':null"
                                            >
                                                <v-select
                                                        v-model="formData.fisherman"
                                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                        label="title"
                                                        :clearable="false"
                                                        :options="fishermanOptions"
                                                >
                                                    <template #no-options>
                                                        <span style="">Sajnáljuk, nincs egyező találat.</span>
                                                    </template>
                                                </v-select>
                                                <b-input-group-append>
                                                    <b-link
                                                            v-b-tooltip.hover
                                                            title="Új horgász létrehozása"
                                                            class="btn btn-secondary"
                                                            @click="showNewFishermanModal"
                                                    >
                                                        <feather-icon icon="PlusIcon"></feather-icon>
                                                    </b-link>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-overlay>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="12">
                                <b-form-group
                                        label="Fogás ideje"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="fogás ideje"
                                            rules="required"
                                            vid="catchTime"
                                    >
                                        <flat-pickr
                                                v-model="formData.catchTime"
                                                class="form-control"
                                                :config="flatPickRConfig"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="12" class="mt-1">
                                <h4>Fogás helye</h4>
                            </b-col>

                            <b-col md="6">
                                <b-form-group
                                        label="Vízterület"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="vízterület"
                                            rules="required"
                                            vid="water"
                                    >
                                        <b-overlay
                                                :show="waterSelectLoading"
                                                spinner-variant="primary"
                                                spinner-type="grow"
                                                rounded="sm"
                                        >
                                            <v-select
                                                    v-model="formData.water"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    label="title"
                                                    :clearable="false"
                                                    :options="waterOptions"
                                            >
                                                <template #no-options>
                                                    <span style="">Sajnáljuk, nincs egyező találat.</span>
                                                </template>
                                            </v-select>
                                        </b-overlay>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="6">
                                <b-form-group
                                        label="Hely"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="hely"
                                            rules=""
                                            vid="fishingPlace"
                                    >
                                        <b-form-input
                                                v-model="formData.fishingPlace"
                                                :state="errors.length > 0 ? false:null"
                                                placeholder=""
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="12" class="mt-1">
                                <h4>Hal</h4>
                            </b-col>

                            <b-col md="3">
                                <b-form-group
                                        label="Halfaj"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="halfaj"
                                            rules="required"
                                            vid="fishType"
                                    >
                                        <b-overlay
                                                :show="fishTypeSelectLoading"
                                                spinner-variant="primary"
                                                spinner-type="grow"
                                                rounded="sm"
                                        >
                                            <v-select
                                                    v-model="formData.fishType"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    label="title"
                                                    :clearable="false"
                                                    :options="fishTypeOptions"
                                            >
                                                <template #no-options>
                                                    <span style="">Sajnáljuk, nincs egyező találat.</span>
                                                </template>
                                            </v-select>
                                        </b-overlay>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="3">
                                <b-form-group
                                        label="Tömeg"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="tömeg"
                                            rules="required"
                                            vid="weight"
                                    >
                                        <b-input-group>
                                            <b-form-input
                                                    v-model="formData.weight"
                                                    type="number"
                                                    lang="hu"
                                                    :state="errors.length > 0 ? false:null"
                                                    :step="0.01"
                                                    :min="0"
                                            />
                                            <b-input-group-append>
                                                <b-input-group-text>kg</b-input-group-text>
                                            </b-input-group-append>
                                        </b-input-group>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="3">
                                <b-form-group
                                        label="Hossz"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="hossz"
                                            rules=""
                                            vid="length"
                                    >
                                        <b-input-group>
                                            <b-form-input
                                                    v-model="formData.length"
                                                    type="number"
                                                    lang="hu"
                                                    :state="errors.length > 0 ? false:null"
                                                    :min="0"
                                            />
                                            <b-input-group-append>
                                                <b-input-group-text>cm</b-input-group-text>
                                            </b-input-group-append>
                                            <small class="text-danger">{{ errors[0] }}</small>
                                        </b-input-group>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="3">
                                <b-form-group
                                        label="Kerület"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="kerület"
                                            rules=""
                                            vid="perimeter"
                                    >
                                        <b-input-group>
                                            <b-form-input
                                                    v-model="formData.perimeter"
                                                    type="number"
                                                    lang="hu"
                                                    :state="errors.length > 0 ? false:null"
                                                    :min="0"
                                            />
                                            <b-input-group-append>
                                                <b-input-group-text>cm</b-input-group-text>
                                            </b-input-group-append>
                                            <small class="text-danger">{{ errors[0] }}</small>
                                        </b-input-group>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="12">
                                <b-form-group
                                        label="Csali"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="csali"
                                            rules="required"
                                            vid="bait"
                                    >
                                        <b-overlay
                                                :show="baitSelectLoading"
                                                spinner-variant="primary"
                                                spinner-type="grow"
                                                rounded="sm"
                                        >
                                            <v-select
                                                    v-model="formData.bait"
                                                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                                    label="title"
                                                    :clearable="false"
                                                    :options="baitOptions"
                                            >
                                                <template #no-options>
                                                    <span style="">Sajnáljuk, nincs egyező találat.</span>
                                                </template>
                                            </v-select>
                                        </b-overlay>
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="12" class="mb-1">
                                <validation-provider
                                        #default="{ errors }"
                                        name="visszaengedve"
                                        vid="released"
                                >
                                    <b-form-checkbox
                                            v-model="formData.released"
                                            :state="errors.length > 0 ? false:null"
                                    >
                                        Visszaengedve?
                                    </b-form-checkbox>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-col>

                            <b-col md="12">
                                <b-form-group
                                        label="Verseny"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="verseny"
                                            rules=""
                                            vid="competition"
                                    >
                                        <b-form-input
                                                v-model="formData.competition"
                                                :state="errors.length > 0 ? false:null"
                                                placeholder=""
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="12">
                                <b-form-group
                                        label="Beszámoló"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="beszámoló"
                                            rules=""
                                            vid="report"
                                    >
                                        <editor
                                                v-model="formData.report"
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="12">
                                <b-form-group
                                        label="Idegen kulcs"
                                >
                                    <validation-provider
                                            #default="{ errors }"
                                            name="idegen kulcs"
                                            rules=""
                                            vid="foreignKey"
                                    >
                                        <b-form-input
                                                v-model="formData.foreignKey"
                                                :state="errors.length > 0 ? false:null"
                                                placeholder=""
                                        />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                            </b-col>

                            <b-col md="12">
                                <validation-provider
                                        #default="{ errors }"
                                        name="látható"
                                        vid="visible"
                                >
                                    <b-form-checkbox
                                            v-model="formData.visible"
                                            :state="errors.length > 0 ? false:null"
                                    >
                                        Látható?
                                    </b-form-checkbox>
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-col>

                            <!-- submit button -->
                            <b-col class="mt-1">
                                <b-button
                                        variant="primary"
                                        type="submit"
                                        class="float-right"
                                        @click.prevent="submitForm"
                                >
                                    Mentés
                                </b-button>
                                <cancel-and-g-o-t-o-previous-page class="mr-2"/>
                            </b-col>
                        </b-row>
                    </b-form>
                </validation-observer>
            </b-overlay>
            <new-fisherman
                    ref="newFishermanModal"
                    @refresh-fishermen="refreshFishermen"
            />
        </b-card-code>
        <b-card-code>
            <tabs
                    ref="tabs"
                    @refresh-tabs-data="refreshTabsData"
                    :entity-id="parseInt(this.$route.params.id)"
            />
        </b-card-code>
    </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {
    BFormInput, BFormGroup, BForm, BRow, BCol, BButton, BFormCheckbox, BInputGroup,
    BInputGroupAppend, BInputGroupText, BLink, BOverlay, VBTooltip,
} from 'bootstrap-vue'
import {
    required,
} from '@validations'
import vSelect from 'vue-select'
import tabs from '@/views/pages/_components/_tabs/_recordCatch/update.vue'
import cancelAndGOTOPreviousPage from '@/views/pages/_components/_helper/cancelAndGOTOPreviousPage'
import newFisherman from "@/views/pages/_components/_modal/record-catch/newFisherman";
import editor from '@/views/pages/_components/editor.vue'
import labels from "@/libs/datepicker/labels";
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css';
import {Hungarian} from 'flatpickr/dist/l10n/hu.js'

export default {
    components: {
        BCardCode,
        ValidationProvider,
        ValidationObserver,
        BFormInput,
        BFormGroup,
        BForm,
        BRow,
        BCol,
        BButton,
        BFormCheckbox,
        BInputGroup,
        BInputGroupAppend,
        BInputGroupText,
        BLink,
        BOverlay,
        flatPickr,
        editor,
        vSelect,
        tabs,
        cancelAndGOTOPreviousPage,
        newFisherman,
        VBTooltip,
    },
    directives: {
        'b-tooltip': VBTooltip,
    },
    data() {
        return {
            role: 'record_catch',
            userSelectLoading: false,
            fishermanSelectLoading: false,
            fishTypeSelectLoading: false,
            baitSelectLoading: false,
            waterSelectLoading: false,
            formData: {
                id: '',
                createdBy: '',
                user: '',
                fisherman: '',
                fishType: '',
                water: '',
                bait: '',
                catchTime: '',
                weight: '',
                length: '',
                perimeter: '',
                report: '',
                released: false,
                foreignKey: '',
                competition: '',
                fishingPlace: '',
                visible: false,
            },
            flatPickRConfig: {
                enableTime: true,
                dateFormat: 'Y-m-d H:i',
                locale: Hungarian,
                allowInput: true
            },
            currentFishermanId: '',
            userOptions: [],
            fishermanOptions: [],
            fishTypeOptions: [],
            waterOptions: [],
            baitOptions: [],
            loading: false,
            required,
            labels,
        }
    },
    created() {
        this.initEntity()
        //this.refreshImages()
    },
    methods: {
        initEntity() {
            this.loading = true
            this.$store.dispatch('fetchRecordCatch', this.$route.params.id).then(response => {

                const entity = response.data.entity;

                this.currentFishermanId = entity.fisherman_id

                this.formData = {
                    id: this.$route.params.id,
                    createdBy: entity.created_by,
                    user: entity.created_by,
                    fisherman: entity.fisherman_id,
                    fishType: entity.fish_type_id,
                    water: entity.water_id,
                    bait: entity.bait_id,
                    catchTime: entity.catch_time,
                    weight: entity.weight,
                    length: entity.length,
                    perimeter: entity.perimeter,
                    report: entity.report,
                    released: !!entity.released,
                    competition: entity.competition,
                    fishingPlace: entity.fishing_place,
                    foreignKey: entity.foreign_key,
                    visible: !!entity.visible,
                }

                this.refreshUser()

                this.fishTypeSelectLoading = true

                this.$store.dispatch('fetchFishTypesForSelect').then(ftResponse => {
                    this.fishTypeOptions = ftResponse

                    if (this.fishTypeOptions.length) {
                        Object.keys(ftResponse).forEach(key => {
                            if (ftResponse[key].value === parseInt(response.data.entity.fish_type_id)) {
                                this.formData.fishType = ftResponse[key]
                            }
                        })
                    }
                }).finally(() => {
                    this.fishTypeSelectLoading = false
                })

                this.waterSelectLoading = true

                this.$store.dispatch('fetchWatersForSelect').then(waResponse => {
                    this.waterOptions = waResponse

                    if (this.waterOptions.length) {
                        Object.keys(waResponse).forEach(key => {
                            if (waResponse[key].value === parseInt(response.data.entity.water_id)) {
                                this.formData.water = waResponse[key]
                            }
                        })
                    }
                }).finally(() => {
                    this.waterSelectLoading = false
                })

                this.baitSelectLoading = true

                this.$store.dispatch('fetchBaitsForSelect').then(baResponse => {
                    this.baitOptions = baResponse

                    if (this.baitOptions.length) {
                        Object.keys(baResponse).forEach(key => {
                            if (baResponse[key].value === parseInt(response.data.entity.bait_id)) {
                                this.formData.bait = baResponse[key]
                            }
                        })
                    }
                }).finally(() => {
                    this.baitSelectLoading = false
                    this.loading = false
                })
            })
        },
        showNewFishermanModal() {
            this.$refs.newFishermanModal.setUser(this.formData.user.value)
            this.$bvModal.show('form-record-catch-new-fisherman-modal')
        },
        refreshUser() {
            this.userSelectLoading = true
            this.$store.dispatch('fetchUsersForSelect').then(response => {
                this.userOptions = response

                if (this.userOptions.length) {
                    Object.keys(response).forEach(key => {
                        if (response[key].value === parseInt(this.formData.createdBy)) {
                            this.formData.user = response[key]
                        }
                    })
                }
            }).finally(() => {
                this.userSelectLoading = false
                this.refreshFishermen();
            })
        },
        refreshFishermen(fishermanId = null) {
            this.fishermanSelectLoading = true
            this.fishermanOptions = []
            this.$store.dispatch('fetchFishermenForSelect', {user_id: this.formData.user.value}).then(response => {
                this.fishermanOptions = response

                if (this.fishermanOptions.length) {
                    if (fishermanId) {
                        Object.keys(response).forEach(key => {
                            if (response[key].value === fishermanId) {
                                this.formData.fisherman = response[key]
                            }
                        })
                    } else {
                        let found = false
                        Object.keys(response).forEach(key => {
                            if (response[key].value === parseInt(this.currentFishermanId)) {
                                this.formData.fisherman = response[key]
                                found = true
                            }
                        })

                        if (!found) {
                            this.formData.fisherman = response[0]
                        }
                    }
                }
            }).finally(() => {
                this.fishermanSelectLoading = false
            })
        },
        refreshTabsData() {
            this.$refs.tabs.refreshImages()
            this.$refs.tabs.refreshLog()
        },
        submitForm() {
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    let fd = {...this.formData}
                    fd.user = this.formData.user.value
                    fd.fisherman = this.formData.fisherman.value
                    fd.fishType = this.formData.fishType.value
                    fd.water = this.formData.water.value
                    fd.bait = this.formData.bait.value

                    this.$store.dispatch('updateRecordCatch', fd).then(response => {
                        this.$helpers.showSuccessToast('Rekord módosítva.')
                        this.$acl.canEditPermission(this.role)
                            ? this.$router.push({name: 'record-catches'})
                            : this.$router.go(-1)
                    }).catch(error => {
                        if (error.response.status === 422) {
                            this.$refs.simpleRules.setErrors(error.response.data.errors)
                        } else {
                            this.$helpers.showErrorToast(error.toString())
                        }
                    })
                }
            })
        },
    },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
<style>
.input-group .v-select {
    flex: 1 1 auto;
}

[dir="ltr"] .input-group:not(.has-validation) .vs__dropdown-toggle:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}
</style>
